export default __webpack_public_path__ + "static/media/bd brochure.fd97df17.pdf";